/**
 * Runs async tasks strictly in enqueue order: each starts only after the
 * previous one settles. Serializes draft saves so a slower earlier save
 * can't land after a newer one and overwrite it.
 */
export const createSerialPromiseQueue = () => {
  let tail: Promise<unknown> = Promise.resolve();

  return function enqueue<T>(task: () => Promise<T>): Promise<T> {
    // Start the task only once the previous one settles (whether it resolved or
    // rejected), so a single failed save never blocks the queue.
    const run = tail.then(task, task);
    tail = run.then(
      () => undefined,
      () => undefined,
    );
    return run as Promise<T>;
  };
};
